// GlobalStyle.js
import { createGlobalStyle } from "styled-components";

const getDeviceBarHeight = () => {
  if (typeof window !== 'undefined') {
    const height = localStorage.getItem('deviceBarHeight');
    return height ? `${Number(height)}px` : '0px';
  }
  return '0px';
};

const deviceBarHeight = getDeviceBarHeight();

const GlobalStyle = createGlobalStyle`
  :root {
    --device-bar-height: ${deviceBarHeight};
  }

  body {
    font-family: 'Inter', sans-serif;
  }

  .h-screen {
    height: 100vh;
    height: 100dvh;
  }

  .min-h-screen {
    min-height: 100vh;
    min-height: 100dvh;
  }

  .max-h-screen {
    max-height: 100vh;
    max-height: 100dvh;
  }

  .h-screen-95 {
    height: 95vh;
    height: 95dvh;
  }

  .safe-area-bottom {
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }

  .safe-area-top {
    padding-top: env(safe-area-inset-top, var(--device-bar-height));
  }

  .safe-area-all {
    padding-top: env(safe-area-inset-top, var(--device-bar-height));
    padding-bottom: env(safe-area-inset-bottom, 0px);
    padding-left: env(safe-area-inset-left, 0px);
    padding-right: env(safe-area-inset-right, 0px);
  }
`;

export default GlobalStyle;
